<template>
  <v-card elevation="2" outlined class="mx-auto">
    <base-expansion-panel :inputs="shukkaZumiAnkenList.inputs" :reactiveVar="reactiveVar">
      <base-form
        :searchBtn="true"
        :resetBtn="true"
        :inputs="shukkaZumiAnkenList.inputs"
        :reactiveVar="reactiveVar"
        @submit-form="handleSubmit"
      >
      </base-form>
    </base-expansion-panel>
    <v-card-subtitle>{{
      `${labels.SHUKKA_DATE}: ${shippingDateFromTo.from ?? ''} 〜 ${shippingDateFromTo.to ?? ''}`
    }}</v-card-subtitle>
    <base-table
      :headers="shukkaZumiAnkenList.headers"
      :items="filteredAnkens ?? shukkaZumiAnkenItems"
      :columnName="[
        'item.base_name',
        'item.comment_count',
        'item.bikou_list',
        'item.hikiwatashiCancel',
        'item.shorui',
        'item.total_weight',
        'item.tracking_number',
        'item.edit',
      ]"
      :itemKey="itemKey"
      :itemClass="itemClass"
      multiSort
      showSelect
      minWidth="1800"
      @row-selected="
        (selected) => {
          this.rowSelected = selected;
        }
      "
    >
      <template v-slot:[`item.base_name`]="{ item }">
        <td style="min-width: 120px; text-align: center">
          <span v-if="item.base_name != null">{{ item.base_name }} </span>
        </td>
      </template>

      <template v-slot:[`item.comment_count`]="{ item }">
        <lazy>
          <v-btn
            color="primary"
            x-small
            align="center"
            justify="center"
            @click="
              getDataShukkaZumiAnkenCommentActions([item.shipping_seq_number]);
              rowComment = item.shipping_seq_number;
              showModal = true;
            "
            >開く</v-btn
          >
        </lazy>
        <div align="center" justify="center">
          <div class="comment-text">
            {{ item.comment_count ? item.comment_count + '件' : '' }}
            {{ item.last_comment_date }}
          </div>
        </div>
      </template>
      <template v-slot:[`item.total_weight`]="{ item }">
        <td style="text-align: right">
          <span v-if="item.total_weight != null">{{ item.total_weight.commaString(' kg') }}</span>
        </td>
      </template>
      <template v-slot:[`item.bikou_list`]="{ item }">
        <v-textarea
          v-if="item.editing"
          filled
          hide-details="true"
          :value="item.bikou_list"
          @change="
            editShukkaZumiAnkenItemsActions([
              {
                shipping_seq_number: item.shipping_seq_number,
                new_bikou_list: $event,
              },
            ])
          "
        ></v-textarea>
        <div v-else-if="item.bikou_list" style="min-width: 100px">
          <span style="line-break: anywhere" v-for="ele in item.bikou_list.split('\n')" :key="ele"
            >{{ ele }}<br
          /></span>
        </div>
      </template>
      <template v-slot:[`item.hikiwatashiCancel`]="{ item }">
        <div v-if="role">
          <lazy>
            <v-btn
              color="red accent-4 white--text"
              x-small
              v-if="!item.editing"
              @click="
                showDangerModal = true;
                showDangerConfirmModal(item);
              "
              >キャンセル</v-btn
            >
          </lazy>
        </div>
      </template>
      <template v-slot:[`item.shorui`]="{ item }">
        <lazy>
          <v-btn
            color="primary"
            x-small
            @click="
              downloadMergedExcels({
                format: 'url',
                shippingSeqNumbers: [item.shipping_seq_number],
                attachmentsIncluded: true,
              })
            "
            >dl</v-btn
          >
        </lazy>
      </template>
      <template v-slot:[`item.tracking_number`]="{ item }">
        <v-textarea
          v-if="item.editing"
          filled
          hide-details="true"
          :value="item.tracking_number"
          @change="
            editShukkaZumiAnkenItemsActions([
              {
                shipping_seq_number: item.shipping_seq_number,
                new_tracking_number: $event,
              },
            ])
          "
        ></v-textarea>
        <span class="wrap-text" v-else>{{ item.tracking_number }}</span>
      </template>
      <template v-slot:[`item.edit`]="{ item }">
        <lazy>
          <div v-if="role">
            <v-btn
              v-if="item.editing"
              text
              icon
              color="green lighten-2"
              @click="
                updateShukkaZumiAnkenItemsActions([
                  {
                    shippingSeqNumber: item.shipping_seq_number,
                    bikou: item.new_bikou_list,
                    trackingNumber: item.new_tracking_number,
                  },
                ])
              "
            >
              <v-icon large>mdi-content-save</v-icon>
            </v-btn>
            <v-btn
              v-else
              text
              icon
              color="blue lighten-2"
              @click="
                editShukkaZumiAnkenItemsActions([
                  {
                    shipping_seq_number: item.shipping_seq_number,
                    editing: true,
                  },
                ])
              "
            >
              <v-icon large>mdi-pencil-box</v-icon>
            </v-btn>
            <v-btn
              v-if="item.editing"
              text
              icon
              color="red lighten-2"
              @click="
                editShukkaZumiAnkenItemsActions([
                  {
                    shipping_seq_number: item.shipping_seq_number,
                    editing: false,
                    new_bikou_list: item.bikou_list,
                    new_tracking_number: item.tracking_number,
                  },
                ])
              "
            >
              <v-icon large>mdi-close-circle</v-icon>
            </v-btn>
          </div>
        </lazy>
      </template>
    </base-table>
    <v-card-actions class="justify-center pt-0 pb-4">
      <csv-result-dl
        :disabled="shukkaZumiAnkenItems.length === 0"
        :item-key="itemKey"
        :row-selected="rowSelected"
      ></csv-result-dl>
      <v-btn color="success" @click="showCslMatchingModal = true">{{ label.CSL_MATCHING }}</v-btn>
    </v-card-actions>
    <commentModal
      :show-modal="showModal"
      :items="commentItems"
      :role="role"
      @close="closeModal"
      @commentRegist="commentRegist"
    >
    </commentModal>
    <DangerConfirmModal
      :show-modal="showDangerModal"
      :message="dangerMessage"
      :confirmText="dangerConfirmText"
      @click:confirm="handleDangerConfirm"
      @click:close="handleClose"
    />

    <v-dialog v-model="showCslMatchingModal" max-width="400px">
      <v-card color="white">
        <v-card-title class="primary text-subtitile-2 white--text py-1">
          <v-icon color="white" large>mdi-magnify</v-icon>
          <span>{{ label.CSL_MATCHING }}</span>
        </v-card-title>
        <v-card-text class="mt-3">{{ messages.CSL_MATCHING_DESCRIPTION }}</v-card-text>
        <v-col class="pl-5">
          <v-checkbox color="primary" :label="label.MEMBER_NAME" v-model="cslMatchingTarget.memberName"></v-checkbox>
          <v-checkbox
            color="primary"
            :label="label.ACCOUNT_HOLDER"
            v-model="cslMatchingTarget.accountHolderCompanyName"
          ></v-checkbox>
          <v-checkbox
            color="primary"
            :label="label.SHIP_TO_COMPANY_NAME"
            v-model="cslMatchingTarget.shipToCompanyName"
          ></v-checkbox>
          <v-checkbox color="primary" :label="label.CEO_NAME" v-model="cslMatchingTarget.ceoName"></v-checkbox>
          <div v-if="rowSelected.length === 0" class="mt-3">
            <label for="first-num">{{ label.NUM_OF_MATCHING }} : </label>
            <input
              type="number"
              min="1"
              :max="shukkaZumiAnkenItems.length"
              style="width: 50px; background-color: gainsboro"
              v-model="numOfMatching"
            />件
          </div>
        </v-col>
        <v-card-actions class="justify-end">
          <v-btn
            v-if="rowSelected.length > 0"
            color="primary"
            outlined
            @click="cslMatching(false)"
            :disabled="
              (!cslMatchingTarget.memberName &&
                !cslMatchingTarget.accountHolderCompanyName &&
                !cslMatchingTarget.shipToCompanyName &&
                !cslMatchingTarget.ceoName) ||
              intervalId
            "
            >{{ label.MATCHING }}</v-btn
          >
          <v-btn
            v-else
            color="primary"
            outlined
            @click="cslMatching(true)"
            :disabled="
              (!cslMatchingTarget.memberName &&
                !cslMatchingTarget.accountHolderCompanyName &&
                !cslMatchingTarget.shipToCompanyName &&
                !cslMatchingTarget.ceoName) ||
              numOfMatching <= 0 ||
              numOfMatching > shukkaZumiAnkenItems.length ||
              intervalId
            "
            >{{ label.MATCHING }}</v-btn
          >
          <v-btn color="warning" text @click="closeCslMatchingModal">{{ labels.BTN_CANCEL }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showCslMatchingCompleteModal" max-width="450px">
      <v-card color="white">
        <v-card-title class="success text-subtitile-2 white--text py-1">
          <v-icon color="white" large>mdi-checkbox-marked-circle-outline</v-icon>
          <span>{{ label.CSL_MATCHING_RESULT }}</span>
        </v-card-title>
        <v-card-text class="mt-3">{{ messages.CSL_MATCHING_COMPLETE }}</v-card-text>
        <v-card-actions class="justify-end">
          <v-btn color="primary" outlined @click="closeCslMatchingCompleteModal">{{ labels.CLOSE }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { executePage, label } from '@/consts.js';
import { mapActions, mapGetters, mapMutations } from 'vuex';
export default {
  components: {
    commentModal: () => import(/* webpackChunkName: "commentModal" */ '@/components/ui/commentModal.vue'),
    DangerConfirmModal: () =>
      import(/* webpackChunkName: "DangerConfirmModal" */ '@/components/ui/DangerConfirmModal.vue'),
    lazy: () => import(/* webpackChunkName: "Lazy" */ '@/components/ui/Lazy.vue'),
  },
  name: 'shukkaZumiAnken',
  data() {
    return {
      itemKey: 'shipping_seq_number',
      showModal: false,
      rowComment: '',
      showDangerModal: false,
      dangerConfirmText: '',
      dangerMessage: '',
      role: false,
      rowSelected: [],
      cslMatchingTarget: {
        memberName: true,
        accountHolderCompanyName: true,
        shipToCompanyName: true,
        ceoName: true,
      },
      showCslMatchingModal: false,
      showCslMatchingCompleteModal: false,
      defaultNumOfMatching: 1,
      numOfMatching: 1,
      requestId: null,
      intervalId: null,
      filteredAnkens: null,
    };
  },
  computed: {
    ...mapGetters({
      shukkaZumiAnkenList: 'defined/shukkaZumiAnkenList',
      reactiveVar: 'shukkaZumiAnken/reactiveVar',
      shukkaZumiAnkenItems: 'shukkaZumiAnken/shukkaZumiAnkenItems',
      commentItems: 'shukkaZumiAnken/commentItems',
      path: 'defined/pathNames',
      messages: 'defined/messages',
      labels: 'defined/labels',
      user: 'defined/user',
      currentBases: 'base/currentBases',
    }),
    label() {
      return label;
    },
    shippingDateFromTo() {
      const keys = Object.keys(this.reactiveVar);
      const hasInputs = keys
        .map((key) => {
          if (key !== 'shukkaDate') {
            if (this.reactiveVar[key]?.[0] || this.reactiveVar[key]?.[1]) {
              return 1;
            } else if (
              typeof this.reactiveVar[key] === 'string' &&
              this.reactiveVar[key] &&
              this.reactiveVar[key] !== ''
            ) {
              return 1;
            }
          }
        })
        .filter(Boolean)
        .reduce((a, b) => a + b, 0);

      const today = new Date();
      const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
      const endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      const inputEndDate = new Date(this.reactiveVar.shukkaDate[1]);
      const from = this.reactiveVar?.shukkaDate?.[0]
        ? new Date(this.reactiveVar.shukkaDate[0])
        : !this.reactiveVar.shukkaDate[0] && this.reactiveVar.shukkaDate[1]
          ? new Date(inputEndDate.getFullYear(), inputEndDate.getMonth(), 1)
          : startOfMonth;
      const to = this.reactiveVar?.shukkaDate?.[1] ? inputEndDate : endOfMonth;
      if (hasInputs > 0) {
        return {
          from: this.reactiveVar?.shukkaDate?.[0] ?? '2022/9/13',
          to: to.toLocaleDateString('ja-jp') ?? to,
        };
      }
      return {
        from: from?.toLocaleDateString().includes('Invalid') ? '' : (from?.toLocaleDateString('ja-jp') ?? from),
        to: to.toLocaleDateString().includes('Invalid') ? '' : (to.toLocaleDateString('ja-jp') ?? to),
      };
    },
  },
  async created() {
    this.role = await this.getRole({
      page: this.path.SHUKKA_ZUMI_ANKEN,
      authority: this.user.authority,
    });
    await this.getDataShukkaZumiAnkenItemsActions(this.reactiveVar);
  },
  methods: {
    ...mapActions({
      getDataShukkaZumiAnkenItemsActions: 'shukkaZumiAnken/getDataShukkaZumiAnkenItemsActions',
      getDataShukkaZumiAnkenCommentActions: 'shukkaZumiAnken/getDataShukkaZumiAnkenCommentActions',
      editShukkaZumiAnkenItemsActions: 'shukkaZumiAnken/editShukkaZumiAnkenItemsActions',
      updateShukkaZumiAnkenItemsActions: 'shukkaZumiAnken/updateShukkaZumiAnkenItemsActions',
      registCommentActions: 'shukkaZumiAnken/registCommentActions',
      downloadMergedExcels: 'api/downloadMergedExcels',
      getRole: 'common/getRole',
      apiCslMatching: 'api/cslMatching',
      apiGetCslMatchingResultCsv: 'api/getCslMatchingResultCsv',
    }),
    ...mapMutations({}),
    async commentRegist(val, noticeTeams = []) {
      await this.registCommentActions({
        comment: val,
        noticeTeams: noticeTeams,
        shippingSeqNumber: this.rowComment,
      });
      this.getDataShukkaZumiAnkenItemsActions(this.reactiveVar);
      this.closeModal();
    },
    closeModal() {
      this.rowComment = '';
      this.commentItems = [];
      this.showModal = false;
    },
    itemClass(item) {
      if (item.editing) {
        return 'highlight-green not-change-hover-color';
      }
      return '';
    },
    showDangerConfirmModal(info) {
      // this.showDangerModal = true;
      this.dangerConfirmText = info.shipping_seq_number;
      this.dangerMessage = this.messages.SHIPMENT_CANCEL_CONFIRM;
    },
    async handleDangerConfirm() {
      await this.updateShukkaZumiAnkenItemsActions([
        {
          shippingSeqNumber: this.dangerConfirmText,
          cancelFlag: 1,
        },
      ]);
      this.showDangerModal = false;
    },
    handleClose() {
      this.showDangerModal = false;
      this.dangerConfirmText = '';
    },
    handleSubmit() {
      const submit = JSON.parse(JSON.stringify(this.reactiveVar));
      const date = (d) => {
        const a = new Date(d.replaceAll('/', '-'));
        return new Date(a - a.getTimezoneOffset() * 60 * 1000).toISOString().split('T')[0];
      };
      submit.shukkaDate[0] = date(this.shippingDateFromTo.from);
      submit.shukkaDate[1] = date(this.shippingDateFromTo.to);
      this.getDataShukkaZumiAnkenItemsActions(submit);
    },
    closeCslMatchingModal() {
      this.showCslMatchingModal = false;
      this.numOfMatching = this.defaultNumOfMatching;
      this.cslMatchingTarget = {
        memberName: true,
        accountHolderCompanyName: true,
        shipToCompanyName: true,
        ceoName: true,
      };
      clearInterval(this.intervalId);
      this.intervalId = null;
    },
    closeCslMatchingCompleteModal() {
      this.showCslMatchingCompleteModal = false;
      this.numOfMatching = this.defaultNumOfMatching;
      this.cslMatchingTarget = {
        memberName: true,
        accountHolderCompanyName: true,
        shipToCompanyName: true,
        ceoName: true,
      };
    },
    async cslMatching(random) {
      this.requestId = this.user.userId + '-' + new Date().getTime();
      let selectedMatters = [];
      if (random) {
        const bufferItems = [...this.shukkaZumiAnkenItems];
        for (let i = 0; i < this.numOfMatching; i += 1) {
          const index = Math.floor(Math.random() * 100) % bufferItems.length;
          selectedMatters.push(bufferItems[index]);
          bufferItems.splice(index, 1);
        }
      } else {
        selectedMatters = this.shukkaZumiAnkenItems.filter((x) =>
          this.rowSelected.map((y) => y.shipping_seq_number).includes(x.shipping_seq_number),
        );
      }
      const payload = {
        requestId: this.requestId,
        selectedMatters,
        target: this.cslMatchingTarget,
        executePage: executePage.SHIPPED_MATTER_LIST,
      };
      await this.apiCslMatching(payload);

      const getResultPayload = {
        requestId: this.requestId,
        csvFlag: true,
      };
      let csvUrl = '';
      this.intervalId = setInterval(async () => {
        csvUrl = await this.apiGetCslMatchingResultCsv(getResultPayload);
        if (csvUrl) {
          clearInterval(this.intervalId);
          this.intervalId = null;
          this.showCslMatchingModal = false;
          this.showCslMatchingCompleteModal = true;
        }
      }, 3000);
    },
    ankenFilter() {
      this.filteredAnkens = this.shukkaZumiAnkenItems.filter((item) => {
        const baseIds = this.currentBases.map((base) => base.id);
        const res = baseIds.includes(item.base_id);
        return res;
      });
    },
  },
  watch: {
    currentBases() {
      this.ankenFilter();
    },
    shukkaZumiAnkenItems(shukkaZumiAnkenItems) {
      if (this.currentBases.length > 0) {
        this.ankenFilter();
      } else {
        this.filteredAnkens = shukkaZumiAnkenItems;
      }
    },
  },
};
</script>
<style>
.wrap-text {
  white-space: pre;
}
.comment-text {
  font-size: xx-small;
}
</style>
